import axios, { AxiosInstance } from 'axios';
import { Endpoints } from '../endpoints';

export interface ContactAddress {
  address1: string;
  address2?: string;
  address3?: string;
  address4?: string;
  city: string;
  state: string;
  stateId: string;
  zip: string;
}

export interface ContactDetail {
  contactDetailId: string;
  contactDetailType: string;
  name: string;
  value: string;
  typeId: string | null;
}
export interface GetContactInfoResponse {
  phoneNumbers?: ContactDetail[];
  emailAddresses?: ContactDetail[];
  address: ContactAddress;
  name: string;
}

export const getContactInfo = async (instance: AxiosInstance = axios) =>
  instance.get<GetContactInfoResponse>(Endpoints.Contact.GET_INFO);

export interface UpdateContactInfoRequest {
  phoneNumbers?: ContactDetail[];
  emailAddresses?: ContactDetail[];
  address: ContactAddress;
}

export interface UpdateContactInfoResponse {}

export const updateContactInfo = async (
  request: UpdateContactInfoRequest,
  instance: AxiosInstance = axios,
) => instance.put<UpdateContactInfoResponse>(Endpoints.Contact.UPDATE_CONTACT_INFO, request);
